module.exports = __webpack_public_path__ + "img/icon-logicom.96e8384a.svg";